<template>
  <b-modal
    @close="onClose"
    :full-screen="isFullScreen"
    :active.sync="opened"
    width="500px"
  >
    <div class="card">
      <div class="card-content">
        <div class="section-block">
          <span class="title">SIGN IN</span>
        </div>

        <form @submit.prevent="login">
          <validation-observer v-slot="{ valid }">
            <validation-provider
              name="email"
              rules="required|email"
              v-slot="{ errors }"
            >
              <b-field :message="errors" :type="{ 'is-danger': errors.length }">
                <b-input
                  v-model="form.username"
                  placeholder="Email Address"
                  type="email"
                ></b-input>
              </b-field>
            </validation-provider>

            <validation-provider
              name="password"
              rules="required"
              v-slot="{ errors }"
            >
              <b-field :message="errors" :type="{ 'is-danger': errors.length }">
                <b-input
                  v-model="form.password"
                  placeholder="Password"
                  type="password"
                ></b-input>
              </b-field>
            </validation-provider>

            <div class="tw-flex tw-mb-5 tw-px-1">
              <b-checkbox v-model="form.remember_me">Remember Me</b-checkbox>
            </div>

            <div class="level">
              <div class="level-left">
                <router-link
                  class="is-family-secondary is-size-6"
                  :to="{ name: 'password.email' }"
                  >Reset Password</router-link
                >
              </div>
              <div class="level-right">
                <b-button
                  :disabled="!valid || isSubmitting"
                  :loading="isSubmitting"
                  native-type="submit"
                  type="is-primary"
                  >Sign In</b-button
                >
              </div>
            </div>
          </validation-observer>
        </form>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ModalMixin from '@/utils/mixins/modal'

export default {
  mixins: [ModalMixin],
  metaInfo: {
    title: 'Login'
  },
  data() {
    return {
      opened: true,
      isSubmitting: false,
      form: {
        username: '',
        password: '',
        remember_me: false
      }
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth
    })
  },
  methods: {
    ...mapActions({
      getCurrentGroup: 'getCurrentGroup'
    }),
    onClose() {
      this.$router.push({ name: 'home' })
    },
    async login() {
      this.isSubmitting = true
      await this.$store
        .dispatch('auth/login', this.form)
        .then(() => {
          this.$router.replace({ name: 'home' })
        })
        .catch(({ response }) => {
          if (response) {
            this.$buefy.snackbar.open({
              type: 'is-danger',
              message: response.data.message,
              position: 'is-top'
            })
          }
        })
        .finally(() => {
          this.isSubmitting = false
        })
      await this.getCurrentGroup()
    }
  }
}
</script>
